import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTreeview,_vm._g(_vm._b({key:_vm.key,ref:"wTreeview",staticClass:"w-treeview",attrs:{"dense":"","open":_vm.openIds},on:{"update:open":function($event){_vm.openIds=$event}},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'v-treeview',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }